import { Component, ViewChild } from "@angular/core";
import { BaseEntity, BaseState, CredentialInfo } from '@base/entities/BaseEntities';
import { BasePageComponent } from '@base/component/BasePageComponent';
import { ServiceBagService, ServiceBagServices } from '@base/component/ServiceBag';
import { DataSourceCustomAction } from "@base/datalayer/BaseDataSources";
import { GridExtender } from "@base/grid/Grid.extender";
import { UserActivityStatusGridComponent } from './grid/useractivitystatus-grid.component';
import { UserActivityEndpoint } from "@core/endpoints/useractivity.endpoint";

class State extends BaseState {
    CredentialsInfo: CredentialInfo[] = [];
    CredentialType: number = -1;
}

@Component({
    providers: ServiceBagServices,
    selector: 'm4u-usersactivitystatus',
    templateUrl: './usersactivitystatus.component.html',
    styleUrls: ['./usersactivitystatus.component.scss']
})

export class UsersActivityStatusComponent extends BasePageComponent<BaseEntity, State>
{
    @ViewChild('userActivityGrid') userActivityGrid: UserActivityStatusGridComponent;
    public get G(): GridExtender { return this.userActivityGrid?.G }

    constructor(A: ServiceBagService, private userActivityEndpoint: UserActivityEndpoint) {
        super(A, 'UsersActivityStatusComponent', BaseEntity, State);
    }

    override OnInitDataSources() {
        this.LoadDataSource();
        this.Do(this.userActivityEndpoint.ListCredentialsInfo(), false, (response) => {
            this.State.CredentialsInfo = response.Entities;

            response.Entities.forEach(entity => {
                if (entity.Value == null) { entity.Value = -999; }
            });
        });
    }

    private LoadDataSource() {
        this.DataSources['Data'] = new DataSourceCustomAction((options) => this.userActivityEndpoint.ListActivity(this.State.CredentialType ?? -999, options), undefined, (entities) => {
            entities.forEach(entity => {
                if (entity.CredentialType == null) { entity.CredentialType = -999; }
            });
        }, false);
        this.DS('Data').Reload();
    }

    override OnGetToolbarSettings() {
        return {
            IsAllowFilter: true,
            IsAllowExport: true,
            GridExtender: this.G
        };
    }

    protected override OnApplyFilter() {
        this.LoadDataSource();
    }

    protected override OnClearFilter() {
        this.State.CredentialType = -1;
        this.LoadDataSource();
    }
}
